const getPrefixForPropertyKey = (propertyKey, prefix) => {
  const maybeNumberPropertyKey = Number(propertyKey);

  // If the property key is a string, add single quotes surrounding it. Otherwise it's a number
  // and we should just index as-is
  // https://goessner.net/articles/JsonPath/
  if (isNaN(maybeNumberPropertyKey)) {
    return prefix ? `${prefix}['${propertyKey}']` : `['${propertyKey}']`;
  }
  return prefix ? `${prefix}[${propertyKey}]` : `[${propertyKey}]`;
};
export const mapWebhookDataToDropdownOptions = (obj, mappings, prefix = '') => {
  const arr = [];
  if (!obj) {
    return arr;
  }
  Object.keys(obj).forEach(key => {
    const newPrefix = getPrefixForPropertyKey(key, prefix);
    if (typeof obj[key] === 'object') {
      arr.push({
        text: key,
        options: mapWebhookDataToDropdownOptions(obj[key], mappings, newPrefix)
      });
    } else {
      arr.push({
        value: newPrefix,
        text: key,
        disabled: !!mappings.find(mapping => mapping.webhookMapping.property === newPrefix)
      });
    }
  });
  return arr;
};
export const getInitialMappingFromDropDown = dropdown => {
  return dropdown.flatMap(option => {
    if ('value' in option) {
      return {
        webhookMapping: {
          property: option.value,
          name: option.value,
          type: null
        },
        typeError: 'EMPTY'
      };
    } else {
      return getInitialMappingFromDropDown(option.options);
    }
  });
};